/**
 * 实例数据类型
 */
export enum InstanceDataType {
    /** 框架 */
    Framework = 'framework',
    /** 触摸数据 */
    TouchData = 'touchData',
    /** 触摸监听列表 */
    TouchListenerList = 'touchListenerList',
}

/** 多实例数据管理 */
export class InstanceData {
    private static instancesData: Record<
        string,
        {
            /** 框架 */
            [InstanceDataType.Framework]: unknown;
            /** 触摸数据 */
            [InstanceDataType.TouchData]: unknown;
            /** 触摸监听列表 */
            [InstanceDataType.TouchListenerList]: unknown;
            /** 销毁列表 */
            destroyList: unknown[];
        }
    > = {};

    /** 销毁实例事件 */
    static onDestroy(identity: string, listener: (identity: string) => void) {
        this.instancesData[identity] = this.instancesData[identity] || {};
        this.instancesData[identity].destroyList = this.instancesData[identity].destroyList || [];
        this.instancesData[identity].destroyList.push(listener);
    }

    /** 获取实例数据 */
    static getData<T>(identity: string, type: InstanceDataType): T {
        return this.instancesData[identity]?.[type] as T;
    }

    /** 设置实例数据 */
    static setData(identity: string, type: InstanceDataType, data: unknown) {
        this.instancesData[identity] = this.instancesData[identity] || {};
        this.instancesData[identity][type] = data;
    }

    /** 删除实例 */
    static delInstance(identity: string) {
        this.instancesData[identity]?.destroyList?.forEach((listener) => (listener as (i: string) => void)(identity));
        delete this.instancesData[identity];
    }
}
